import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { ButtonIconPosition, ButtonStatus } from './Button.types';

type ButtonClassNames = ComponentClassNames<'baseButton' | 'content' | 'spinner' | 'iconWrapper' | 'secondaryText'>;
type GetClassNames = (
  status: ButtonStatus,
  iconPosition: ButtonIconPosition,
  hasText: boolean,
  className: string | undefined
) => ButtonClassNames;
export const getClassNames: GetClassNames = memoizeFunction((status, iconPosition, hasText, className) =>
  mergeStyleSets({
    baseButton: [{ fontFamily: 'inherit' }, className],
    content: {
      visibility: status === 'loading' ? 'hidden' : undefined,
    },
    spinner: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    iconWrapper: {
      paddingLeft: iconPosition === 'right' && hasText ? '4px' : 0,
      paddingRight: iconPosition === 'left' && hasText ? '5px' : 0,
    },
    secondaryText: {
      visibility: 'hidden',
      overflow: 'hidden',
      height: 0,
    },
  })
);
